import React, { FC } from 'react';
import styles from './ReceivedVariablesTable.module.scss';
import TableRow from './TableRow';
import { EditExternalIntegrationVariablesPopUpState } from 'EditExternalIntegrationVariablesPopUp/Types';
import SkeletonIntegrationLine from 'components/ExternalIntegration/Tables/SkeletonIntegrationLine';
import RulesListTableHeader from 'components/RulesListTableHeader';

const TABLE_TITLE = 'Variables Received from Integration';
const TABLE_DESCRIPTION =
  'The following data items are received from the integration \n and the values will be assigned to the variables below.';

interface TableHeaderProps {
  dataItem: string;
  usedVariable: string;
}

interface ReceivedVariablesTableProps {
  externalIntegrationInfo: EditExternalIntegrationVariablesPopUpState;
  isLoading: boolean;
  onOpenAssignOutputVariablePopUp: (assignedOutput: string) => void;
}

const DEFAULT_ROWS_AMOUNT = 10;

const TableHeader: FC<TableHeaderProps> = ({ dataItem, usedVariable }) => (
  <div className={styles.ruleRow}>
    <div className={styles.dataItem}>{dataItem}</div>
    <div className={styles.variable}>{usedVariable}</div>
  </div>
);

const ReceivedVariablesTable: FC<ReceivedVariablesTableProps> = ({
  externalIntegrationInfo,
  onOpenAssignOutputVariablePopUp,
  isLoading,
}) => {
  const { outputList, numberVariables, stringVariables, booleanVariables, dateVariables } = externalIntegrationInfo;
  const variableList = isLoading ? new Array(DEFAULT_ROWS_AMOUNT).fill(null) : outputList;

  return (
    <div className={styles.container}>
      <RulesListTableHeader title={TABLE_TITLE} description={TABLE_DESCRIPTION} />
      <TableHeader dataItem="Data Item Name" usedVariable="Variable Assigned" />
      {variableList.map((variable, index) => {
        if (variable === null) {
          return <SkeletonIntegrationLine key={index} />;
        }
        return (
          <TableRow
            key={index}
            variable={variable}
            numberVariables={numberVariables}
            stringVariables={stringVariables}
            booleanVariables={booleanVariables}
            dateVariables={dateVariables}
            onOpenAssignOutputVariablePopUp={onOpenAssignOutputVariablePopUp}
          />
        );
      })}
    </div>
  );
};

export default ReceivedVariablesTable;
